import { mapActions, mapState, mapGetters } from 'vuex';

export default {
    computed: {
        ...mapState('project', ['projects', 'uploadInformation']),
        ...mapGetters('project', ['getPlayerFrontURL', 'getPlayerEmbedURL', 'shouldAskInformation', 'validatedProjects']),
    },
    methods: {
        ...mapActions('project', ['getProjects', 'uploadFiles', 'updateProjects', 'updateUploadInformation', 'addUploadInformation']),
    },
};
